import { useEffect, useState } from 'react';

import { Analytics } from '@watershed/analytics/analyticsUtils';
import { maybeNotifySentry } from '@watershed/shared-frontend/utils/errorUtils';
import {
  LOGIN_CUSTOMER_RELATION_OPTIONS,
  LoginCustomerRelationOption,
} from '@watershed/shared-universal/dashboardRoutes';

import { RecipientOrgMetadata } from '../types';
import { fetchRecipientOrgMetadata } from '../utils/fetchUtils';

interface UseRecipientMetadataParams {
  customerRelation: LoginCustomerRelationOption | null;
  customerCompanyId: string | null;
  recipientCompanyId: string | null;
}

export function useRecipientMetadata({
  customerRelation,
  customerCompanyId,
  recipientCompanyId,
}: UseRecipientMetadataParams): RecipientOrgMetadata {
  const [recipientMetadata, setRecipientMetadata] =
    useState<RecipientOrgMetadata>({
      orgDomains: [],
      orgName: null,
      customerName: '',
    });

  useEffect(() => {
    const fetchOrgDomainsAndSetState = async (
      recipientCompanyId: string | null,
      customerCompanyId: string
    ) => {
      let metadata;
      try {
        metadata = await fetchRecipientOrgMetadata(customerCompanyId, {
          recipientCompanyId,
        });
      } catch (ex) {
        const error = ex as Error;
        maybeNotifySentry(error);
        Analytics.error('fetchOrgData', {
          error: error.message,
        });
      }
      if (metadata !== undefined) {
        setRecipientMetadata(metadata);
      }
    };

    if (
      customerRelation === LOGIN_CUSTOMER_RELATION_OPTIONS.SUPPLIER &&
      customerCompanyId
    ) {
      void fetchOrgDomainsAndSetState(recipientCompanyId, customerCompanyId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerRelation, recipientCompanyId]);

  return recipientMetadata;
}
